module.exports = __webpack_public_path__ + "static/media/art16.6c1a8f3e.png";